<template>
    <b-card
        class="apprentice-simple-card-with-banner internship-card"
        no-body
        @click="showInternshipModalDetail">
        <b-card-img
            class="internship-banner"
            :src="internshipBanner()"></b-card-img>

        <div class="internship-header">
            <slot name="header"></slot>
        </div>
        <b-card-body body-class="internship-card-body body">
            <b-card-title title-tag="h5">
                {{ internshipIn.name }}
            </b-card-title>

            <div class="internship-card-description muted-text">
                {{ internshipIn.description | editor_text_preview(20) }}
            </div>

            <span class="load-more btn-show-all">{{ $t('common.more') }}</span>
        </b-card-body>
    </b-card>
</template>

<script>
export default {
    name: 'design-2021-internships-student-internship-card-component',
    props: {
        internshipIn: {
            type: Object,
            required: true,
        },
    },
    methods: {
        internshipBanner() {
            return this.internshipIn.file
                ? this.internshipIn.file.path
                : `https://apprentice-portalxm.s3.eu-central-1.amazonaws.com/production/general/course-stage.jpg`;
        },
        showInternshipModalDetail() {
            this.$emit('show-modal-detail', this.internshipIn);
        },
    },
};
</script>

<style scoped lang="scss">
.internship-card {
    margin-bottom: $grid-gutter-width;

    .internship-header {
        position: absolute;
        top: map-get($grid-gutter-spacing, 'fifteen');
        right: map-get($grid-gutter-spacing, 'fifteen');

        .actions {
            display: flex;
            align-items: center;
            justify-content: flex-start;
            column-gap: map-get($grid-gutter-spacing, 'ten');

            .btn:before {
                margin-right: 0;
            }
        }
    }

    .internship-banner {
        height: 150px;
        width: 100%;
        object-fit: cover;
        object-position: center;
        border-top-left-radius: 12px;
        border-top-right-radius: 12px;
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
    }

    .body {
        display: flex;
        flex-direction: column;
        background-color: $secondary-background-color;
        padding: map-get($grid-gutter-spacing, 'fifteen');
        text-align: left;
    }
}

.internship-card-description {
    margin-top: map-get($grid-gutter-spacing, 'eight');
    margin-bottom: map-get($grid-gutter-spacing, 'forty-two');
}

.load-more {
    justify-content: flex-end;
    font-size: $default-font-size;
    font-weight: $font-weight-bold;
    color: $nav-link-color;
    margin-top: auto;
}
</style>
